<template>
  <base-dialog class="select-excel-tpl" show-close :visible="visible" @open="open" @closed="close">
    <template v-slot:header>
      <div>导出数据</div>
    </template>
    <div v-loading="loadingTemplates">
      <div v-if="!templateList || templateList.length === 0" class="empty">
        该工作表暂无Excel导出模板
      </div>
      <el-table
        v-else
        :data="templateList"
        highlight-current-row
        @current-change="handleCurrentChange"
      >
        <el-table-column label="模板名称" width="150">
          <template slot-scope="scope">
            <div class="circle-wrap">
              <div
                class="circular"
                :class="{ active: selTemplate && scope.row.id === selTemplate.id }"
              ></div>
              <span>{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="desc" label="描述"></el-table-column>
      </el-table>
    </div>

    <div slot="footer">
      <base-button @click="close">取 消</base-button>
      <base-button type="primary" @click="submit">确 定</base-button>
    </div>
  </base-dialog>
</template>

<script>
import * as ExcelTplApi from "@/api/appManage/excel-template"
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"

export default {
  name: "select-excel-tpl",
  props: {
    visible: Boolean,
    sheetId: String,
    appId: String,
    refSheetId: { type: String, default: "" }
  },
  components: {
    BaseDialog,
    BaseButton
  },
  data() {
    return {
      loadingTemplates: false,
      templateList: [],
      selTemplate: { name: "默认模板", desc: "使用默认方式导出", id: "default" }
    }
  },
  methods: {
    // 打开
    open() {
      this.templateList = []
      this.loadingTemplates = true
      ExcelTplApi.getExcelTemplateList(this.appId, this.sheetId, this.refSheetId).then(res => {
        this.templateList = [{ name: "默认模板", desc: "使用默认方式导出", id: "default" }].concat(
          res
        )
        this.loadingTemplates = false
      })
    },
    close() {
      this.$emit("update:visible", false)
    },
    submit() {
      this.close()
      this.$emit("submit", this.selTemplate)
    },
    // 当前选中项改变
    handleCurrentChange(val) {
      if (val && val.id) this.selTemplate = val
    }
  }
}
</script>
<style lang="scss" scoped>
.select-excel-tpl {
  .header-wrapper {
    display: flex;
    .svg-icon {
      margin-left: auto;
      cursor: pointer;
    }
  }
  .empty {
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #c0c4cc;
  }
  ::v-deep .el-dialog__body {
    padding: 16px 24px;
    .el-table__row {
      cursor: pointer;
      td {
        vertical-align: top;
      }
    }
    .circle-wrap {
      display: flex;
      align-items: center;
      span {
        margin-left: 8px;
        line-height: 20px;
      }
    }
    .circular {
      position: relative;
      border: 1px solid #dcdfe6;
      border-radius: 100%;
      display: inline-block;
      width: 14px;
      height: 14px;
      &::after {
        content: "";
        transform: translate(-50%, -50%) scale(0);
      }
    }
    .active {
      position: relative;
      border-color: #409eff;
      background: #409eff;
      &:after {
        content: "";
        width: 4px;
        height: 4px;
        border-radius: 100%;
        background-color: #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) scale(1);
        transition: transform 0.15s ease-in;
      }
    }
  }
}
</style>
